import env from "./.env";

export const environment = {
  production: true,
  productionBD: true, // ДЛЯ ВЫПЛАТ
  version: env.npm_package_version,
  serverUrl: "https://backend-3.tr-portal.ru/",
  envName: "PROD",
};
